import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import './tab-panel.scss';
import ShareButton from './shareButton.vue';
import TabMenuButton from './tabMenuButton.vue';
import { NotificationService } from '../notification/notification.service';

const defaultTab = {
  route: "overview",
  value: "tab_title_invoice_info",
  vgi_id: "release_setup",
};
const defaultOption = {
  text: "Documents",
  value: "documents",
  classes: "",
};

@Component
export class TabPanel extends Vue {
  @Prop({ required: true }) tabs; // = [defaultTab];
  @Prop({ required: false, default: () => [] }) options; // = [defaultOption];
  @Prop({ required: false, default: () => [] }) shareOptions; // = [defaultOption];
  @Prop({ required: false, default: () => [] }) menu; // = [defaultOption];

  @Prop({ required: false }) tabPanelRight; // = [defaultOption];

  get scrollHighlightedTab() {
    // console.log({"highlightedTab": this.$parent});
    // return false;
    return this.$parent?.highlightedTab;
  }

  onTabItemClick(index, tab) {
    this.$parent.tabSelected(index);

    // TOD: Remove this After DT Grid Is implemented Everywhere
    // DT Grid Implementation
    if (this.$parent.onTabSelected) {
      this.$parent.onTabSelected(tab);
    }
  }
  onOptionClick(option) {
    if (!option.text) {
      throw Error("Pass in a valid option Array in the TabPanel Component inside the Sidewindow");
    }
    this.$emit('optionClicked', option.value ? option.value : option.text);
  }

  get showOptionsPanel() {
    return this.options?.length > 0 || this.shareOptions?.length > 0 || this.menu?.length > 0;
  }

  isItemActive(item) {
    // console.log({"highlightedTab": this.$parent});
    // if(this.$route.params.tab == item.route){
    //   console.log({"this.scrollHighlightedTab": this.scrollHighlightedTab});
    //   console.log({"item.route": item.route});
    //   console.log({"this.$route.params.tab": this.$route.params.tab});
    // }else{
    //   console.log(":::::");
    // }

    return this.scrollHighlightedTab ? this.scrollHighlightedTab == item.route : this.$route.params.tab == item.route;
  }

  onPopupBodyClick(event) {
    const body = event.target;

    navigator.clipboard.writeText(body.innerText).then(
      function () {
        NotificationService.showNotification({
          text: "Info copied to Clipboard",
          timeout: 1000,
        });
      },
      function (err) {
        NotificationService.showNotification({
          text: "Text could not be copied to clipboard",
          timeout: 2000,
          type: "error",
        });
      }
    );
  }

  render(h) {
    return (
      <div class="tab-panel ut-jbetween">
        <div class="tab-panel--left">
          {this.tabs.map((t, index) =>
            <v-btn
              class={`${this.isItemActive(t) ? 'active' : ''} tab-item`}
              flat={true}
              small={true}
              onClick={e => this.onTabItemClick(index, t)}
            >
              {t.value}
            </v-btn>)}
        </div>
        <div class="tab-panel--right ut-flex">
          <div class="div.tab-panel--slot">
            {this.tabPanelRight}
          </div>
          {this.showOptionsPanel ? <div
            class="tabs-options--panel ut-flex"
          >
            <div
              class="tabs-options--panel ut-flex"
            >
              {this.options.map(option => 

                option.popup ? 
                <v-menu
                 close-on-content-click={false}
                 open-on-hover
                 nudge-right="40"
                 lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              
                >
                  <div slot="activator">
                    <button
                      class={`${option.classes} ${option.error ? 'btn-error' : ''} dt-button v5 s8`}
                      style="margin-right: 5px"
                      onClick={e => this.onOptionClick(option)}
                    >
                      {option.text}
                    </button>
                  </div>

                  {
                    option.popup &&  
                    <div 
                      class="info-card-body"
                      onClick={e => this.onPopupBodyClick(e)} 
                      domPropsInnerHTML={option.popup} 
                      style="background-color: white;padding:10px"
                    >
                        
                    </div>
                  }
                </v-menu>: 
                <button
                  class={`${option.classes} ${option.error ? 'btn-error' : ''} dt-button v5 s8 ${option.disabled ? 'disabled': ''} `}
                  style="margin-right: 5px"
                  disabled={option.disabled}
                  title={option.title || ''}
                  onClick={e => this.onOptionClick(option)}
                >
                  {option.text}
                </button>

              
                )
              }
              {this.shareOptions && this.shareOptions.length > 0 ? <ShareButton options={this.shareOptions} onClick={this.onOptionClick} /> : undefined}
              {this.menu && this.menu.length > 0 ? <TabMenuButton style={`margin-left: 4px`} options={this.menu} onClick={this.onOptionClick} /> : undefined}
            </div>
          </div> : undefined}
          {this.$slots.tab_options}
        </div>
      </div>
    );
  }
}
